"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _chunkB2edacfb = require("./chunk-b2edacfb.js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SelectionGroup = _interopRequireDefault(require("./SelectionGroup.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var RadioGroup = function (_PureComponent) {
  (0, _chunkB2edacfb.f)(RadioGroup, _PureComponent);

  function RadioGroup() {
    var _getPrototypeOf2;

    var _this;

    (0, _chunkB2edacfb.b)(this, RadioGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _chunkB2edacfb.d)(this, (_getPrototypeOf2 = (0, _chunkB2edacfb.e)(RadioGroup)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _chunkB2edacfb.h)((0, _chunkB2edacfb.m)(_this), "onChange", function (e) {
      var onChange = _this.props.onChange;
      onChange(e.currentTarget.value);
    });
    (0, _chunkB2edacfb.h)((0, _chunkB2edacfb.m)(_this), "getChildCheckedState", function (optionProps) {
      var value = optionProps.value;
      return value === _this.props.value;
    });
    return _this;
  }

  (0, _chunkB2edacfb.c)(RadioGroup, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_SelectionGroup.default, (0, _chunkB2edacfb.g)({}, this.props, {
        getChildCheckedState: this.getChildCheckedState,
        onChange: this.onChange
      }));
    }
  }]);
  return RadioGroup;
}(_react.PureComponent);

(0, _chunkB2edacfb.h)(RadioGroup, "displayName", "CRadio.Group");
(0, _chunkB2edacfb.h)(RadioGroup, "propTypes", {
  value: _propTypes.default.string,
  onChange: _propTypes.default.func,
  isDisabled: _propTypes.default.bool
});
(0, _chunkB2edacfb.h)(RadioGroup, "defaultProps", {
  value: null,
  isDisabled: false,
  onChange: function onChange() {}
});
RadioGroup.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "getChildCheckedState",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "optionProps",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "CRadio.Group",
  "props": {
    "value": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "isDisabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};
var _default = RadioGroup;
exports.default = _default;